import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  ComponentRef,
  ViewContainerRef,
  ComponentFactoryResolver,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import * as L from 'leaflet';
import 'leaflet-editable';
import 'leaflet-path-drag';
import { MapServicesService } from 'src/app/map/services/map-services.service';
import { PopupContent, UserTracker } from 'src/app/multiview/models/interfaces';
import { CircularGeofencesMinimapService } from 'src/app/multiview/services/circular-geofences-minimap.service';
import { GeofencesMinimapService } from 'src/app/multiview/services/geofences-minimap.service';
import { GeopointsMinimapService } from 'src/app/multiview/services/geopoints-minimap.service';
import { LayersService } from 'src/app/multiview/services/layers.service';
import { SliderMultimediaComponent } from 'src/app/shared/components/slider-multimedia/slider-multimedia.component';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { PopupMap } from '../../models/popup-map';
import { EventService } from '../../services/event.service';
import { DvrGalleryComponent } from '../dvr-gallery/dvr-gallery.component';
import { MapAsideService } from 'src/app/panel/components/map-aside/service/map-aside.service';
import { StateCustomPanelVehicleService } from 'src/app/vehicles/components/content-panel-vehicles/service/state-custom-panel-vehicle.service';
import { EvaluationCriteriaService } from '../../services/evaluation-criteria.service';
import { IsReloadPageService } from 'src/app/vehicles/components/content-panel-vehicles/service/is-reload-page.service';

@Component({
  selector: 'app-event-popup',
  templateUrl: './event-popup.component.html',
  styleUrls: ['./event-popup.component.scss'],
})
export class EventPopupComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() configuration!: PopupContent;
  @Input() uuid!: string;
  @Input() _timeoutId!: any;
  @Output() onDelete: EventEmitter<any> = new EventEmitter<any>();

  mapItem!: PopupMap;
  mapLayers: L.LayerGroup[] = [];

  @ViewChild('appSlider') appSlider!: SliderMultimediaComponent;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];

  has_multimedia = false;
  public unitAux: any;

  constructor(
    public layersService: LayersService,
    public geofencesService: GeofencesMinimapService,
    public circularGeofences: CircularGeofencesMinimapService,
    public geopointsService: GeopointsMinimapService,
    public eventService: EventService,
    public mapService: MapServicesService,
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef,
    private vehicleService: VehicleService,
    private mapAsideService: MapAsideService,
    public servicePanel: StateCustomPanelVehicleService,
    private evaluationCriteriaService: EvaluationCriteriaService,
    private reloadPageService: IsReloadPageService
  ) {}

  ngOnInit(): void {
    this.configuration.vehicles?.forEach((item) => {
      item.latitud = this.configuration.event.latitud;
      item.longitud = this.configuration.event.longitud;
    });
    this.unitAux = this.configuration.vehicles;
    this.configuration.event.parametros = this.paramsToObject(
      this.configuration.event.parametros
    );
    const params = this.configuration.event.parametros;
    if (this.eventService.videoDemandInEvents[this.configuration.event.tipo]){
      this.has_multimedia = false
    }else {
      this.has_multimedia =
        params && (params['has_video'] == '1' || params['has_image'] == '1');
    }
  }

  ngOnDestroy() {
    // Destruye el mapa al salir del componente para evitar el error
    console.log('event slider popup destroy');
    if (this.mapItem) {
      this.mapItem.map!.remove();
    }
    this.clearAllHighlightMarkers();
  }

  ngAfterViewInit() {
    console.log('after view event pop');
    this.createMap();
  }

  createMap() {
    setTimeout(() => {
      const mapContainer = document.getElementById(
        this.configuration.mapConf?.containerId!
      );
      if (mapContainer) {
        this.mapItem = new PopupMap(this.configuration);
        this.mapItem.createMap();
        this.setLayers();
        this.mapItem.drawIcon(
          this.configuration.vehicles!,
          this.configuration.event
        );
      }
    }, 1000);
  }

  deletePopup() {
    console.log('delete Popup: ');
    this.onDelete.emit(this.uuid);
    //this.onDelete.emit(this.configuration.mapConf?.containerId);
    //this.ngOnDestroy();
  }

  setLayers() {
    if (this.layersService.isReady) {
      this.loadLayers();
    } else {
      this.layersService.servicesReady$.subscribe((ready: boolean) => {
        if (ready) {
          // Todos los servicios están listos, puedes ejecutar tu código aquí.
          this.loadLayers();
          //this.mapItem.map!.addLayer(this.mapLayers[0]);
        } else {
          // Al menos uno de los servicios aún no está listo, puedes mostrar un mensaje de carga o realizar otras acciones según tus necesidades.
          console.log('Esperando a que todos los servicios estén listos...');
        }
      });
    }
  }

  private loadLayers() {
    //console.log('¡Todos los servicios están listos!');
    const circular_geofences = this.circularGeofences.getData();
    const geofences = this.geofencesService.getData();
    const geopoints = this.geopointsService.getData();

    const mainLayer = L.tileLayer(
      'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      {
        attribution: '&copy; GL Tracker',
        minZoom: 14,
        maxZoom: 17,
        crossOrigin: true,
        // Otras opciones de configuración de la capa
      }
    );

    mainLayer.addTo(this.mapItem.map!);

    var baseLayers = {
      OpenStreetMap: mainLayer,
    };

    this.mapItem.map!.zoomControl.remove();
    // Crear el control de capas
    L.control.layers(baseLayers).addTo(this.mapItem.map!).remove();

    //this.mapItem.map!.zoomControl.setPosition('topright');

    // this.addGeofencesToMap(circular_geofences);
    // this.addGeofencesToMap(geofences);
    // this.addGeofencesToMap(geopoints);
  }

  private addGeofencesToMap(geofences: any[]) {
    for (const geofence of geofences) {
      //console.log("adding geofence ",geofence);
      if (geofence.zone_visible == 'true') {
        geofence.geo_elemento.addTo(this.mapItem.map!);
      }
      if (geofence.zone_name_visible == 'true') {
        geofence.marker_name.addTo(this.mapItem.map);
      }
    }
  }

  private evaluation_criteria_filter: any[] = [];

  async eventOnMainMap() {
    const flagEventPopup = this.reloadPageService.isOpenPanelEvents;
    const currentEvent = this.configuration.event;
    const typeEvent = currentEvent.tipo;
    if (flagEventPopup) {
      await this.switchTypeEventFilter(typeEvent);
      const newEvent = {
        ...this.configuration.event,
        evaluation_criteria_filter: this.evaluation_criteria_filter,
      };
      const isEvaluated = this.configuration.event.evaluated;
      if (isEvaluated === 0) {
        this.mapAsideService.setValueAuxDisabled(false, null);
      } else {
        const evaluations = Array.isArray(this.configuration.event.evaluations)
          ? this.configuration.event.evaluations
          : [this.configuration.event.evaluations];

        const valueDisabled = {
          criteria_name:
            evaluations[0].criterio_evaluacion || 'No hay criterios',
          url_video: evaluations[0].identificacion_video,
          calification: evaluations[0].valoracion_evento.toString(),
          observation: evaluations[0].observacion_evaluacion,
          operator_name: evaluations[0].operador_monitoreo,
          comunication: evaluations[0].has_radio_communication,
        };
        this.mapAsideService.setValueAuxDisabled(true, valueDisabled);
      }
      this.showEvent({
        ...newEvent,
        flagEventPopup: !flagEventPopup,
        originPopup: true,
      });
      return;
    } else {
      this.showEvent({
        ...this.configuration.event,
        flagEventPopup: !flagEventPopup,
        originPopup: true,
      });
    }
  }

  public async switchTypeEventFilter(event_slug: string): Promise<void> {
    this.evaluation_criteria_filter =
      this.evaluationCriteriaService.getOptionBySlug(event_slug);
  }

  eventOnStreetView() {
    console.log('viendo en street view');
    const urlGS =
      'http://maps.google.com/maps?q=&layer=c&cbll=' +
      this.configuration.event.latitud +
      ',' +
      this.configuration.event.longitud +
      '&cbp=0,' +
      this.configuration.event.angulo +
      ',0,0,0';
    window.open(urlGS, '_blank');
  }

  paramsToObject(params: string): any {
    const objParams: any = {};
    params.split('|').forEach((item: any) => {
      const [key, value] = item.split('=');
      objParams[key] = value;
    });
    return objParams;
  }

  // Método para limpiar todos los marcadores de resaltado
  private clearAllHighlightMarkers() {
    if (
      this.eventService.activeEvent &&
      this.eventService.activeEvent.highlightMarkers
    ) {
      this.eventService.activeEvent.highlightMarkers.forEach((marker: any) => {
        this.mapService.map.removeLayer(marker);
      });
      this.eventService.activeEvent.highlightMarkers = null;
    }

    this.eventService.getData().forEach((event: any) => {
      if (event.highlightMarkers) {
        event.highlightMarkers.forEach((marker: any) => {
          this.mapService.map.removeLayer(marker);
        });
        event.highlightMarkers = null;
      }
    });
  }

  getClassByEvent(event: any): String {
    if (
      ['exceso-velocidad-nivel', 'exceso-velocidad-nivel-direccion'].includes(
        event.tipo
      )
    ) {
      const lvlss = [
        { value: 'Nivel III', lvl: '-lvl3' },
        { value: 'Nivel II', lvl: '-lvl2' },
        { value: 'Nivel I', lvl: '-lvl1' },
      ];
      const _lvl = lvlss.find((lvl) => event.nombre.includes(lvl.value));
      if (_lvl) {
        event.tipo += _lvl.lvl;
      }
    }
    return (
      this.eventService.eventsClassList.find(
        (eventClass: any) => eventClass.tipo == event.tipo
      )?.clase ?? 'default-event'
    );
  }

  private getDistance(lat1: number, lon1: number, lat2: number, lon2: number) {
    const R = 6371; // Radio de la Tierra en km
    const toRad = (degree: number) => degree * (Math.PI / 180);

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  private auxDistante: { lat: number; lon: number; active: boolean } = {
    lat: 0,
    lon: 0,
    active: false,
  };

  async showEvent(event: any) {
    if (this.eventService.activeEvent) {
      this.clearAllHighlightMarkers();
      if (
        this.eventService.activeEvent.id == event.id &&
        event.layer.isPopupOpen()
      ) {
        console.log('no hacer nada');
        return;
      }
      /* this.eventService.activeEvent.layer.closePopup();
      this.eventService.activeEvent.layer.unbindPopup(); */
      this.eventService.activeEvent.layer.off();
      this.hideEvent(this.eventService.activeEvent);
    }
    let reference = await this.eventService.getReference(
      event.latitud,
      event.longitud
    );
    event.referencia = reference.referencia;

    if (!event.viewed) {
      event.viewed = true;
      //this.eventService.markAsRead(event.evento_id);
    }
    this.eventService.activeEvent = event;

    var eventClass: any = this.eventService.eventsClassList.filter(
      (eventClass: any) => eventClass.tipo == event.tipo
    );
    eventClass = eventClass.length > 0 ? eventClass[0].clase : 'default-event';

    const targetLatLng = event.layer.getLatLng();

    const varColor = this.getClassByEvent(event);

    const pulseIcon = L.divIcon({
      className: 'pulse-icon',
      html: `
        <div class="pulse-marker ${varColor}">
          <style>
            .pulse-marker {
              width: 20px;
              height: 20px;
              background: transparent;
              border-radius: 50%;
              position: relative;
              margin-top: 16px;
            }
            .pulse-marker:before {
              content: '';
              position: absolute;
              width: 100%;
              height: 100%;
              background: var(--event-main-color, #2196f3);
              border-radius: 50%;
              animation: pulse 1.5s ease-out infinite;
              z-index: -1;
            }
            @keyframes pulse {
              0% {
                transform: scale(1);
                opacity: 0.5;
              }
              100% {
                transform: scale(3);
                opacity: 0;
              }
            }
          </style>
        </div>
      `,
      iconSize: [20, 20],
      iconAnchor: [10, 10],
    });

    const arrowIcon = L.divIcon({
      className: 'arrow-icon',
      html: `
        <div class="arrow-marker ${varColor}">
          <style>
            .arrow-marker {
              width: 0;
              height: 0;
              border-left: 15px solid transparent;
              border-right: 15px solid transparent;
              border-top: 25px solid var(--event-main-color, #2196f3);
              transform-origin: bottom center;
              animation: bounce 1s infinite;
              margin-top: -24px;
            }
            @keyframes bounce {
              0%, 100% {
                transform: translateY(-10px);
              }
              50% {
                transform: translateY(0);
              }
            }
          </style>
        </div>
      `,
      iconSize: [30, 25],
      iconAnchor: [15, 0],
    });

    const pulseMarker = L.marker([targetLatLng.lat, targetLatLng.lng], {
      icon: pulseIcon,
      zIndexOffset: -1000,
    }).addTo(this.mapService.map);

    const arrowMarker = L.marker([targetLatLng.lat, targetLatLng.lng], {
      icon: arrowIcon,
      zIndexOffset: 1000,
      interactive: false,
      keyboard: false,
      riseOnHover: false,
    }).addTo(this.mapService.map);
    event.highlightMarkers = [arrowMarker, pulseMarker];

    if (this.auxDistante.active) {
      const distance = this.getDistance(
        this.auxDistante.lat,
        this.auxDistante.lon,
        targetLatLng.lat,
        targetLatLng.lng
      );
      if (distance <= 1) {
        this.mapService.map.flyTo([targetLatLng.lat, targetLatLng.lng], 19, {
          animate: true,
          duration: 0.5,
          easeLinearity: 1,
        });
        this.mapService.map.invalidateSize();
      } else {
        this.mapService.map.fitBounds([[targetLatLng.lat, targetLatLng.lng]], {
          padding: [50, 50],
        });
      }
    } else {
      this.auxDistante.active = true;
      this.mapService.map.fitBounds([[targetLatLng.lat, targetLatLng.lng]], {
        padding: [50, 50],
      });
    }

    this.auxDistante.lat = targetLatLng.lat;
    this.auxDistante.lon = targetLatLng.lng;

    const componentRef = this.addMultimediaComponentAsideMap(event);
    this.mapAsideService.show('events', {
      ...event,
      componentRef,
    });
    event.layer.on('click', () => {
      this.mapAsideService.show('events', {
        ...event,
        componentRef,
      });
      this.mapService.map.setView(event.layer.getLatLng(), 19);
    });
    event.layer.addTo(this.mapService.map);

    /* this.eventService.mapService.map.fitBounds([[event.layer.getLatLng().lat, event.layer.getLatLng().lng]], {padding: [50, 50]}); */
    //si el evento es de cipia y tiene video(s)

    /* event.layer.bindPopup(this.eventService.getContentPopup(event), {
      className: eventClass,
      minWidth: 250,
      maxWidth: 350,
    });
    event.layer.on('click', () => {
      console.log("CLIIIIICK");
      this.addMultimediaComponent(event);
      this.addDVRGalleryComponent(event);
    });
    event.layer.addTo(this.eventService.mapService.map).openPopup();

    this.addDVRGalleryComponent(event);
    this.addMultimediaComponent(event); */
  }

  private hideEvent(event: any) {
    this.eventService.mapService.map!.removeLayer(event.layer);
    this.eventService.activeEvent = false;
  }

  showMultimedia() {
    console.log('Mostrando multimedia:');
    this.appSlider.changeShowMultimedia();
  }
  addDVRGalleryComponent(event: any) {
    try {
      const factory = this.resolver.resolveComponentFactory(
        DvrGalleryComponent!
      );
      const componentRef = this.container.createComponent(factory);
      componentRef.instance.event = event;
      const container = document.getElementById(
        'dvrgallery-' + event.uuid_event
      )!;
      container.innerHTML = '';
      container.appendChild(componentRef.location.nativeElement);
      componentRef.changeDetectorRef.detectChanges();
      // this.appRef.tick();
    } catch (error) {
      console.log('Saint', error);
    }
  }

  addMultimediaComponent(event: any) {
    if (
      event.parametros &&
      event.parametros.gps == 'cipia' &&
      (event.parametros.has_video == '0' || event.parametros.has_image == '0')
    ) {
      console.log('adding multimedia: ', event);

      const factory = this.resolver.resolveComponentFactory(
        SliderMultimediaComponent
      );
      const componentRef: ComponentRef<any> =
        this.container.createComponent(factory);
      const params: any = {
        event: event!,
        driver:
          this.vehicleService.vehicles.find((vh) => vh.IMEI == event.imei)
            ?.namedriver ?? '',
        showMultimediaFirst: true,
        hasMultimedia: true,
        showTitle: false,
      };
      // Asignar datos al componente si existen

      Object.keys(params).forEach((key) => {
        componentRef.instance[key] = params[key];
      });
      // Agregar el componente directamente al contenedor del popup
      const divContainer = document.getElementById(
        'multimedia-' + event.uuid_event
      )!;
      divContainer.innerHTML = '';
      divContainer.appendChild(componentRef.location.nativeElement);
    }
  }

  addMultimediaComponentAsideMap(event: any): any {
    if (
        event.parametros?.gps === 'cipia' &&
      (
        event.parametros.has_video !== '0' ||
        event.parametros.has_image !== '0' ||
        (this.eventService.videoDemandInEvents[event.evento])
      )&&
      event.evento != "checklist-daily"
    ) {
      try {
        const factory = this.resolver.resolveComponentFactory(
          SliderMultimediaComponent!
        );
        const componentRef: ComponentRef<any> =
          this.container.createComponent(factory);

        const params: any = {
          event: event!,
          driver:
            this.vehicleService.vehicles.find((vh) => vh.IMEI == event.imei)
              ?.namedriver ?? '',
          showMultimediaFirst: true,
          hasMultimedia: true,
          showTitle: false,
        };
        //console.log(
        //  'eventRowSelected event list',
        //  event,
        //  this.currentRowSelected
        //);

        Object.keys(params).forEach((key) => {
          componentRef.instance[key] = params[key];
        });
        return componentRef;
      } catch (error) {
        console.error('Error adding multimedia component:', error);
      }
    } else {
      return null;
    }
  }
}
